import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Utilities } from "@learningblocks/exp-constants";

const { VISIBILITY } = Utilities;

/**
 * HiddenComponent:
 *  - Hides current component untile visibilty props is set.
 */
export function HiddenComponent({ visibility, children, className: cn }) {
  if (VISIBILITY.HIDDEN === visibility) {
    const className = `${style.wrapper} ${cn}`;
    return (
      <div className={className}>
        <h3 className={style.wrapper_message}>Solve Previous Question</h3>
      </div>
    );
  } else return children;
}

HiddenComponent.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Current state of visibility [visible/hidden]
   */
  visibility: PropTypes.oneOf([VISIBILITY.HIDDEN, VISIBILITY.VISIBLE]),
  /**
   * Component to be displayed when state 'visible'
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

HiddenComponent.defaultProps = {
  visibility: VISIBILITY.VISIBLE,
};
